import { useEffect, useState } from 'react';

import VPeriodSelectorContext from './context';
import type { RangePivot, VPeriodSelectorProps } from './type';

export const VPeriodSelectorContextProvider = <T extends boolean>({
  children,
  periodUnitValue,
  onPeriodUnitChange,
  dateRangeTabList,
  ...props
}: React.PropsWithChildren<VPeriodSelectorProps<T>>) => {
  const [rangePivot, setRangePivot] = useState<RangePivot>(
    dateRangeTabList[periodUnitValue][0],
  );

  useEffect(() => {
    setRangePivot(dateRangeTabList[periodUnitValue][0]);
  }, [periodUnitValue, dateRangeTabList]);

  return (
    <VPeriodSelectorContext.Provider
      value={{
        ...props,
        periodUnitValue,
        onPeriodUnitChange,
        dateRangeTabList,
        rangePivot,
        onRangePivotChange: setRangePivot,
      }}
    >
      {children}
    </VPeriodSelectorContext.Provider>
  );
};
